// MEGAMENU

jQuery(document).ready(function($){

	$('li.industry').hover(function() {
		$('li.application').removeClass('active');
		$('li.products').removeClass('active');
		$(this).addClass('active');
		$('.c-solutions').find('.col.l9').removeClass('active');
		$('.c-industries').addClass('active');
	});

	$('li.application').hover(function() {
		$('li.industry').removeClass('active');
		$('li.products').removeClass('active');
		$(this).addClass('active');
		$('.c-solutions').find('.col.l9').removeClass('active');
		$('.c-applications').addClass('active');
	});

	$('li.products').hover(function() {
		$('li.application').removeClass('active');
		$('li.industry').removeClass('active');
		$(this).addClass('active');
		$('.c-solutions').find('.col.l9').removeClass('active');
		$('.c-products').addClass('active');
	});

});
